import { createIcon } from '@chakra-ui/react';

export const ChevronLeftIcon = createIcon({
  displayName: 'ChevronLeftIcon',
  viewBox: '0 0 32 32',
  path: (
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M21.5607 6.91842C22.1464 7.47631 22.1464 8.38083 21.5607 8.93873L13.6213 16.5L21.5607 24.0613C22.1464 24.6192 22.1464 25.5237 21.5607 26.0816C20.9749 26.6395 20.0251 26.6395 19.4393 26.0816L10.4393 17.5102C9.85355 16.9523 9.85355 16.0477 10.4393 15.4898L19.4393 6.91842C20.0251 6.36053 20.9749 6.36053 21.5607 6.91842Z'
      fill='currentColor'
    />
  ),
});
